import { useLayoutEffect, useMemo } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { publicRouter } from "./Routes/router";
import { ProtectedRoute, GetLocalStorage } from "./shared/HigherOrderComponent";
import Master from "./shared/Layouts/Master";
import {
  routeComponentMap,
  staticComponents,
} from "./Routes/routeComponentMap";
import {
  checkSessionExpiry,
  validateTokenOnRefresh,
} from "./store/user/user-action";

const buildRoutes = (items = []) => {
  return items.flatMap((item) => {
    const Component = routeComponentMap[item.formKey];
    const routes = [];

    if (Component) {
      routes.push(
        <Route
          key={`${item.formId}-${item.formPath}`}
          path={item.formPath}
          element={<Component />}
        />,
      );
    }

    if (item.formKey === "Import") {
      staticComponents.import.forEach((route) => {
        const StaticComponent = route.component;

        routes.push(
          <Route
            key={route.key}
            path={route.path}
            element={<StaticComponent />}
          />,
        );
      });
    }

    if (item.children?.length) {
      routes.push(...buildRoutes(item.children));
    }

    return routes;
  });
};

const buildStaticRoutes = (routes = []) => {
  return routes.map((route) => {
    const Component = route.component;

    return <Route key={route.key} path={route.path} element={<Component />} />;
  });
};

const App = () => {
  const menu = useSelector((state) => state.user.formList);
  const dynamicRoutes = useMemo(() => buildRoutes(menu || []), [menu]);
  const userSessionRoutes = useMemo(
    () => buildStaticRoutes(staticComponents.user_session),
    [],
  );
  const publicRoutes = useMemo(
    () =>
      publicRouter.map((route) => {
        const Component = route.component;
        return (
          <Route key={route.path} path={route.path} element={<Component />} />
        );
      }),
    [],
  );

  useLayoutEffect(() => {
    validateTokenOnRefresh();
    checkSessionExpiry();
  }, []);

  return (
    <Routes>
      {/* PRIVATE ROUTES */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Master />}>
          {dynamicRoutes}
          {userSessionRoutes}
        </Route>
      </Route>

      {/* PUBLIC ROUTES */}
      <Route element={<GetLocalStorage />}>{publicRoutes}</Route>

      {/* FALLBACK */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
